// E-Ticaret › Alt Alan (Footer) Ayarları kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.footer';

export const ecommerceFooterGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Footer (alt alan) nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Sitenizin her sayfasının en altında görünen alanı (logo, açıklama, iletişim, sosyal medya, link sütunları, ödeme logoları ve bülten) burada hazırlarsınız. Yaptığınız değişiklikler kendiliğinden kaydedilir; kayıt sırasında başlığın yanında "Kaydediliyor..." görünür. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Footer Ayarları'),
    form: t(`${G}.regions.form`, 'Footer Önizleme ve Genel Ayarlar'),
    list: t(`${G}.regions.list`, 'Logo, iletişim, sosyal medya, sütunlar'),
    footer: t(`${G}.regions.footer`, 'Ödeme Logoları ve Bülten'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Önizleme ve genel ayarlar'),
      text: t(`${G}.s1.text`, '"Footer Önizleme" footer\'ın sitede nasıl görüneceğini gösterir; önizlemedeki öğelere sağ tıklayarak stillerini (boyut, renk) düzenleyebilirsiniz. "Genel Footer Ayarları"nda yazı rengini, arka planı, giriş animasyonunu ve sütun konumunu (sola dayalı, ortada, sağa dayalı) seçin.'),
      tips: [
        t(`${G}.s1.tip1`, 'Sütun konumu sütun grubunu sola veya sağa yaslar; sütun içindeki yazılar her zaman solda kalır.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Logo, açıklama ve iletişim'),
      text: t(`${G}.s2.text`, '"Şirket Açıklaması" logo altında görünen kısa slogandır (en fazla 500 karakter); boş bırakırsanız gizlenir. "Şirket Logo Yönetimi" ve "İkinci Şirket Logo Yönetimi" ile logoları resim kütüphanesinden seçin veya silin. "İletişim Bilgileri Yönetimi"nde adres, telefon, e-posta ve çalışma saatleri İletişim sayfasından otomatik gelir; değiştirmek için "İletişim sayfasında düzenle"yi kullanın.'),
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Sosyal medya ve uygulamalar'),
      text: t(`${G}.s3.text`, '"Sosyal Medya veya Uygulama Ekle" ile platformu, ikon stilini ve bağlantı adresini (URL) girin. İkon boyutunu ve ikon düzenini (Yatay sıra / Izgara) seçin; uygulama mağazası ikonları için ızgara önerilir. Kalem simgesi linki düzenler, çöp kutusu onay sorduktan sonra kalıcı olarak siler.'),
      tips: [
        t(`${G}.s3.tip1`, 'İletişim ikonlarının boyutu sosyal medya ikon boyutuyla birlikte değişir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Link sütunları ve hedef sayfa'),
      text: t(`${G}.s4.text`, '"Hızlı Erişim Yönetimi"nde "Yeni Sütun Ekle" ile link sütunu açın (en fazla 4 sütun) ve "Sütun Adı" yazın (örn. Kurumsal, Kategoriler). "Yeni Hızlı Erişim Linki Ekle" ile "Görünen Ad"ı ve yönlendirme türünü seçin: "Sayfa konumu" ile sitenizdeki bir sayfayı ve istenirse sayfa içindeki bir bölümü seçersiniz (o bölüme yumuşak kaydırma ile inilir), "Özel URL" ile adresi kendiniz yazarsınız.'),
      tips: [
        t(`${G}.s4.tip1`, '1. sütunda sabit linklere (Ana Sayfa, İletişim) ek olarak en fazla 7, diğer sütunlarda en fazla 10 link eklenebilir. En az bir sütun bulunmalıdır; sütun silinince içindeki tüm linkler de silinir.'),
        t(`${G}.s4.tip2`, '"Sütun Sırası" bölümünde Logo / Marka, İletişim, Kampanyalar, Yasal ve link sütunlarını oklarla sol veya sağ kısma taşıyıp sıralayın. Yasal sütunundaki belgeler Yasal Sözleşmeler ekranından gelir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Ödeme logoları'),
      text: t(`${G}.s5.text`, '"Ödeme Logoları" bölümüne Visa, Mastercard gibi logoları sürükleyip bırakın, dosya yükleyin veya resim kütüphanesinden seçin (en fazla 8 logo). Logolar şirket açıklamasının hemen altında görünür; genişlik, yükseklik ve hizalamayı (Sol, Orta, Sağ) ayarlayın.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Bülten bölümü'),
      text: t(`${G}.s6.text`, '"Bülten Bölümünü Göster" açıkken footer\'ın hemen üstünde bir e-posta abonelik bölümü görünür. Başlık, Açıklama (opsiyonel) ve Buton Metni yazın; istenirse "Cinsiyet Seçimini Göster" (Kadın / Erkek) açın, arka plan rengini ve bölüm görselini seçin.'),
      tips: [
        t(`${G}.s6.tip1`, '"Mobil Ayarlar"da görselin mobilde gösterilip gösterilmeyeceğini seçin; kapalıysa mobilde yalnız form görünür. Mobil görsel boş bırakılırsa masaüstü görseli mobil boyutlarıyla kullanılır.'),
        t(`${G}.s6.tip2`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
